// MACHINERY V2 (Stroje) — Špecifikácie tab: the prose blocks (M2.5).
//
// Spec: data package §3 "Conditional" — the description block renders only when
// there is a `primaryText`, and the "EN" encoding-fallback badge appears only
// when the language is Slovak AND the Czech text was mojibake AND the English
// text is non-empty. That third condition is what stops the badge from claiming
// a fallback that never happened; `usedEncodingFallback` is computed once, in
// specResolve.ts, and simply passed through here.
//
// PARAGRAPHS SPLIT ON A BLANK LINE. v1's DescriptionBlock does
// `descriptionText.split(/\n\s*\n/)` and renders each with `whiteSpace:
// pre-line`, which is what keeps Techspex prose readable; same here.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

import useTranslation from "../../../../../shared/hooks/useTranslation";

export const EncodingFallbackBadge: React.FC = () => {
  const { translate } = useTranslation("myMachinery");
  return (
    <span
      title={translate("myMachinery:encodingFallbackNotice")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "1px 7px",
        borderRadius: 999,
        background: "var(--bg-soft)",
        border: "1px solid var(--border)",
        color: "var(--muted)",
        fontFamily: "var(--font-mono)",
        fontSize: 9,
        fontWeight: 600,
        letterSpacing: "0.06em",
        cursor: "help",
        flexShrink: 0,
      }}
    >
      EN
    </span>
  );
};

export const SpecDescription: React.FC<{
  label: string;
  text: string;
  showEncodingFallback?: boolean;
}> = ({ label, text, showEncodingFallback }) => {
  if (!text.trim()) return null;
  const paragraphs = text.split(/\n\s*\n/).filter((p) => p.trim());

  return (
    <div
      style={{
        background: "var(--card)",
        border: "1px solid var(--border)",
        borderRadius: 10,
        boxShadow: "var(--shadow)",
        overflow: "hidden",
        minWidth: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "10px 16px",
          borderBottom: "1px solid var(--border-soft)",
          background: "var(--bg-soft)",
          minWidth: 0,
        }}
      >
        <span
          className="eyebrow"
          style={{
            color: "var(--mod-accent)",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
        {showEncodingFallback && <EncodingFallbackBadge />}
      </div>
      <div style={{ padding: "14px 18px", minWidth: 0 }}>
        {paragraphs.map((paragraph, i) => (
          <div
            key={i}
            style={{
              fontSize: 13.5,
              color: "var(--ink-2)",
              lineHeight: 1.75,
              whiteSpace: "pre-line",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              marginBottom: i < paragraphs.length - 1 ? 12 : 0,
            }}
          >
            {paragraph.trim()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecDescription;
